import React from 'react';
import { 
  Menu,
  MenuItem,
} from '@mui/material';
import { 
  Delete as DeleteIcon,
  CopyAll as CopyAllIcon,
} from '@mui/icons-material';

function ContextMenu({ anchorEl, open, onClose, onCopyId, onDeleteClick }) {
  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
    >
      <MenuItem onClick={onCopyId}>
        <CopyAllIcon sx={{ mr: 1, fontSize: 18 }} />
        Copy document ID
      </MenuItem>
      <MenuItem onClick={onDeleteClick} sx={{ color: '#dc2626' }}>
        <DeleteIcon sx={{ mr: 1, fontSize: 18 }} />
        Delete document
      </MenuItem>
    </Menu>
  );
}

export default ContextMenu;
